import React from "react"

export const Paragraph = ({children}) => {
  return(
    <p className="my-2" style={{ lineHeight: "1.7" }}>
      {children}
    </p>
  )
}